import * as React from 'react';
import { TimePeriodServiceGetResponse, TimePeriodServiceGetUploadFilesResponse } from '../../services/api';
import UploadListItem from './UploadListItem';

export default function UploadHistoryList({ uploads, timePeriod }: { uploads: TimePeriodServiceGetUploadFilesResponse[], timePeriod: TimePeriodServiceGetResponse }) {
  if (!uploads) return;
 
  return (
    <div className="flex flex-col gap-2">
      {uploads.map((file, index) => <UploadListItem timePeriod={timePeriod} file={file} key={index} />)}
    </div>
  );
}